import { apiClient } from '@/lib/api';

export interface UserRoleDto {
  id: string;
  role: string;
  grantedAt: string;
  grantedBy?: string;
  grantedByName?: string;
}

const BASE_URL = '/api/v1/users';

export const userRoleService = {
  async getUserRoles(userId: string): Promise<UserRoleDto[]> {
    const response = await apiClient.get<UserRoleDto[]>(`${BASE_URL}/${userId}/roles`);
    return response.data;
  },

  async addRole(userId: string, role: string): Promise<void> {
    await apiClient.post(`${BASE_URL}/${userId}/roles`, { role });
  },

  async removeRole(userId: string, role: string): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${userId}/roles/${encodeURIComponent(role)}`);
  },
};
